import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=e4c950dc&scoped=true&"
import script from "./OrderComplete.vue?vue&type=script&lang=js&"
export * from "./OrderComplete.vue?vue&type=script&lang=js&"
import style0 from "./OrderComplete.vue?vue&type=style&index=0&id=e4c950dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c950dc",
  null
  
)

export default component.exports